// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce4af572","453":"697de29c","732":"9bff51a8","977":"1dc61c8f"}[chunkId] + ".chunk.js";
};